import { fetcherCMS } from '@/modules/api';
import { getCMSImageFieldsUrl, getCMSLocale } from '@/modules/cms';
import { type CMSApiBase, type CMSImageBase, createCmsUrl } from './base';
import type { CMSFaq, CMSSteps, CMSTextContent } from './restrictions';

export interface FortuneWheelMenuDataApi extends CMSApiBase {
  pageTitle: string;
  menu: {
    bg: CMSImageBase;
    character: CMSImageBase;
    reward: string;
    dailySpins: string;
    tryTomorrow: string;
  };
}

export const getFortuneWheelMenuCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'fortune-wheel',
    queryData: {
      ...getCMSLocale(lang),
      populate: {
        menu: {
          populate: {
            ...getCMSImageFieldsUrl('bg'),
            ...getCMSImageFieldsUrl('character'),
          },
        },
      },
      fields: ['page_title'],
    },
  });

export const getFortuneWheelCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'fortune-wheel',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const getFortuneWheelPageTitleCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'fortune-wheel',
    queryData: {
      ...getCMSLocale(lang),
      fields: ['page_title'],
    },
  });

export const fetchFortuneWheelMenuCMS = async (lang: string) => {
  const response = await fetcherCMS<FortuneWheelMenuDataApi>(
    getFortuneWheelMenuCMSUrl(lang)
  );
  return { data: response };
};

export interface FortuneWheelApi extends CMSApiBase {
  pageTitle: string;
  announceDescription: string;
  description: CMSTextContent[];
  leftCharacter: CMSImageBase;
  rightCharacter: CMSImageBase;
  mobileCharacter: CMSImageBase;
  leftDecor: CMSImageBase;
  rightDecor: CMSImageBase;
  wheelArrow: CMSImageBase;
  topBg: CMSImageBase;
  contentBg?: CMSImageBase;
  contentLeftCharacter?: CMSImageBase;
  contentRightCharacter?: CMSImageBase;
  howToParticipate: CMSSteps[];
  faq: CMSFaq[];
  bonusBuyPromocode?: string;
  wheel: {
    active: CMSImageBase;
    spinning: CMSImageBase;
    finished: CMSImageBase;
    stand?: CMSImageBase;
    sectors?: CMSWheelSector[];
  };
}

export interface CMSWheelSector {
  fs?: number;
  cash?: number;
}

export const fetchFortuneWheelCMS = async (lang: string) => {
  const response = await fetcherCMS<FortuneWheelApi>(
    getFortuneWheelCMSUrl(lang)
  );
  return { data: response };
};

export interface FortuneWheelPageTitleApi extends CMSApiBase {
  pageTitle: string;
}

export const fetchFortuneWheelPageTitleCMS = async (lang: string) => {
  const response = await fetcherCMS<FortuneWheelPageTitleApi>(
    getFortuneWheelPageTitleCMSUrl(lang)
  );
  return { data: response };
};
